module.exports = __webpack_public_path__ + "img/referenceOwners.b4cf621b.svg";